import React from 'react';
import { LinearProgress, Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  progress: {
    borderRadius: 3,
    height: theme.spacing(0.75),
  },
  progressColorSecondary: {
    backgroundColor: 'var(--secondary-color-background)',
  },
}));

interface Props {
  value: number;
}

const Progress: React.FC<Props> = (props: Props): JSX.Element => {
  const classes = useStyles();

  const { value } = props;

  return (
    <LinearProgress
      classes={{
        root: classes.progress,
        colorSecondary: classes.progressColorSecondary,
      }}
      color="secondary"
      value={value}
      variant="determinate"
    />
  );
};

export default Progress;
